import React from 'react'
import moment from 'moment'
import { I18n } from 'react-redux-i18n'

const formatDateTime = (dateTime, dateTimeFormat) =>
  moment(dateTime).format(dateTimeFormat)

export default ({ dailyTimeBoundary }) => {
  if (!dailyTimeBoundary) return null

  const dateTimeFormat = I18n.t('date.shortDateTimeFormat')
  const startDateTime = formatDateTime(dailyTimeBoundary.start, dateTimeFormat)
  const endDateTime = formatDateTime(dailyTimeBoundary.end, dateTimeFormat)

  return (
    <span className="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-semibold bg-gray-100 text-gray-800 border border-gray-200">
      {startDateTime} - {endDateTime}
    </span>
  )
}
